import React from "react";

const MOdalContent = ({ children }) => {
  return <div className="modal-content">{children}</div>;
};

export default MOdalContent;
